import ContactModule from './ContactModule';

export default ContactModule;
